import script from "./Promotions.vue?vue&type=script&setup=true&lang=js"
export * from "./Promotions.vue?vue&type=script&setup=true&lang=js"

import "./Promotions.vue?vue&type=style&index=0&id=2c671932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c671932"]])

export default __exports__